exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fodyn-field__alert > p[data-v-4042b890]:last-child {\n  margin-bottom: 0;\n}\n", ""]);

